<template>
  <ion-page>
    <PageLoading v-if="showLoading"></PageLoading>
    <master-layout @refreshPage="reRender" pageTitle="ثبت سفارش">
      <Loading v-if="!pageLoaded"></Loading>
      <div v-if="pageLoaded">
       <div v-if="!showOrderContainer">
          <ion-card-content >
            <ali-ajax-select class="mb-1" :on-change="changeCustomer" route="getCustomerForSelect"
                             :selected="(customer?[customer]:[])"
                             title="نام / شماره تلفن مشتری (بدون صفر)" itemTitle="fullname" name="fullname"
                             desc="جستجو نام مشتری" itemId="_id"></ali-ajax-select>
            <div v-if="customer" id="customer_info">
              <hr>
              <div class="d-flex-between pb-1">
                <div>
                  {{ customer.fullname }}
                </div>
                <div>
                  {{ customer.phone }}
                </div>
              </div>
              <div class="d-flex-between pb-1">
                <div>
                  سقف خرید :
                  <Money :number="customer.purchase_ceiling?customer.purchase_ceiling:'--'"></Money>
                </div>
                <div>
                  سقف بدهی :
                  <Money :number="customer.debt_ceiling?customer.debt_ceiling:'--'"></Money>
                </div>
              </div>
              <div class="d-flex-between pb-1">
                <div :class="(customer.balance > 0?'text-success':'text-danger')">
                  مانده حساب :
                  <Money :number="Math.abs(customer.balance)"></Money>&nbsp;
                  <span v-if="customer.balance > 0">طلبکار</span>
                  <span v-if="customer.balance < 0">بدهکار</span>
                </div>
              </div>
              <div>
                <div>
                  <span v-if="customer.plans">پلن :
                  <b class="plans" v-for="(c,index) in customer.plans" :key="index" :style="'background:'+ c.color+';'">{{c.title}}</b>
                  </span>
                  <span v-else>پلن : --</span>
                </div>
              </div>
              <div v-if="true">
                <router-link :to="'/customer/Edit/'+customer._id">
                  <button class="btn btn-success">
                    نمایش اطلاعات
                  </button>
                </router-link>&nbsp;
              </div>
            </div>
          </ion-card-content>
        <div v-if="customer">

          <IonRow v-if="!flag">
            <IonCol size="12">
              <input type="search" v-model="search_product" class="form-control search-input mt-1" placeholder="جستجو محصول..">
            </IonCol>
            <IonCol size="6">
              <label>برند محصول</label>
              <AliSelect :on-change="changeBrand" search="true" title="برند محصول" v-if="brands.length"
                         :items="brands" item-id="_id" item-title="title" name="brand_id"></AliSelect>
            </IonCol>
            <IonCol size="6">
              <label>دسته بندی محصول</label>
              <AliSelect :on-change="changeCategory" search="true" title="دسته بندی محصول" v-if="categories.length"
                         :items="categories" item-id="_id" item-title="title" name="category_id"></AliSelect>
            </IonCol>
          </IonRow>
          <div v-if="!flag">
          <ion-card class="product-card" v-for="(item,index) in filteredProducts" :key="index">
            <ion-card-content>
              <div class="img-div"><img :src="item.pic_url"></div>
              <div>{{ item.product_title }}</div>
              <div v-if="item.attr_str">({{ item.attr_str }})</div>
              <div v-if="item.sku">{{item.sku}}</div>
              <div class="d-flex-between pb-1 mt-1">
                <div>موجودی</div>
                <div> <Money :number="item.quantity"></Money> عدد</div>
                <div>
                  <span v-if="item.bigger_unit">{{ Number((item.quantity/item.bigger_unit_quantity).toFixed(2))}} {{item.bigger_unit_title}}</span>
                  <span v-else>--</span>
                </div>
              </div>
              <div class="d-flex-between pb-1">
                <div>قیمت</div>
                <div> <Money :number="item.price"></Money></div>
                <div>
                  <Money v-if="item.bigger_unit_quantity" :number="(item.price*item.bigger_unit_quantity)"></Money>
                  <Money v-else :number="item.price"></Money>
                </div>
              </div>
              <div class="d-flex-between pb-1">
                <div>
                  <div v-if="true">
                  <div v-if="!item.bigger_unit">تکی</div>
                  <div v-else-if="item.bigger_unit">
                    <select autocomplete="off" v-model="item.current_unit" class="form-control"
                            name="unit_type">
                      <option value="small">تکی</option>
                      <option value="big">{{ item.bigger_unit_title }}</option>
                    </select>
                  </div>
                  </div>
                </div>
                <div>
                  <span @click.prevent="decrement(index)" class="input-number-decrement">–</span>
                  <input @keypress="isNumber($event)" class="input-number" type="tel" v-model="item.selected_qty" min="0" max="10">
                  <span @click.prevent="increment(index)" class="input-number-increment">+</span>
                </div>
              </div>
            </ion-card-content>
          </ion-card>
            <div class="alert alert-danger center mt-1" v-if="!filteredProducts.length">موردی یافت نشد</div>
          </div>
          <ion-card-content v-if="flag" class="mt-1">
            <div >
              <ajax-form route="submitOrder" :callback="submitOrderCallback">
                <input type="hidden" readonly :value="customer._id" name="customer_id">
                <div v-if="orderItems.length>0" class="table-responsive">
                  <table class="table">
                    <thead>
                    <tr>
                      <th>ردیف</th>
                      <th>عنوان کالا</th>
                      <th>تعداد واحد1</th>
                      <th>تعداد واحد2</th>
                      <th>مبلغ واحد1</th>
                      <th>مبلغ</th>
                      <th>حذف</th>
                    </tr>
                    </thead>
                    <tbody>
                    <order-item @del_items="removeItem(index)"  v-for="(item,index) in orderItems" :key="index" :index="index" :item="item" @itemChanged="(v)=>{setItem(v,index)}"></order-item>
                    </tbody>
                  </table>
                </div>
                <div v-else><p>هیچ کالایی در لیست سفارشات شما وجود ندارد.</p><br></div>
                <br>
                <div v-if="orderItems.length>0">
                  <div class="end-list-products">
                    <div class="">تعداد اقلام: {{ order_qty }}</div>
                    <div class="">جمع کل: <Money :number="order_total"></Money></div>
                  </div>
<!--                  <div class="form-group">-->
<!--                    <label>تخفیف</label>-->
<!--                    <NumberInput name="discount_amount"  placeholder="تخفیف" />-->
<!--                  </div>-->
                </div>
                <br>
                <input v-if="mission_item_id" type="hidden" name="mission_item_id" :value="mission_item_id" readonly>
                <div v-if="stock_error" class="div-danger p-1">موجودی کافی برای محصولات مشخص شده وجود ندارد.سفارش در وضعیت درخواست ثبت میشود و باید برای ثبت به تایید مدیریت برسد.<i class="far fa-info-circle pulse"></i> </div>
                <div>
                  <label>توضیحات شما برای مدیریت:</label>
                  <textarea class="form-control" name="visitor_description" placeholder="توضیحات شما"></textarea>
                </div>
                <div class="mt-1 mb-1">
                  <label class="d-block">نحوه پرداخت مشتری : </label>
                  <div class=" form-check form-check-inline">
                    <input type="checkbox" class="form-check-input" name="payment_type[]" autocomplete="off" value="cash" id="exampleCheck1">
                    &nbsp;<label class="form-check-label" for="exampleCheck1">نقدی</label>
                  </div>
                  <div class=" form-check form-check-inline">
                    <input type="checkbox" class="form-check-input" id="exampleCheck2"
                           name="payment_type[]" autocomplete="off" value="credit"
                    >
                    &nbsp;<label class="form-check-label" for="exampleCheck2">غیرنقدی</label>
                  </div>
                  <div class=" form-check form-check-inline">
                    <input type="checkbox" class="form-check-input" id="exampleCheck3"
                           name="payment_type[]" autocomplete="off" value="contract"
                    >
                   &nbsp;<label class="form-check-label" for="exampleCheck3">قراردادی</label>
                  </div>

                </div>
                <input v-if="location" name="location" type="hidden" v-model="location" readonly>
                <button ref="confirm_submit_btn" @click="submitOrder()" v-if="orderItems.length>0" class="btn btn-success" type="button">ثبت فاکتور</button>&nbsp;
                <button type="button" class="btn btn-warning" @click="flag=false">افزودن محصول</button>&nbsp;
                <button v-if="orderItems.length>0" type="button" class="btn btn-danger" @click="confirmRemoveFactor"><i class="fal fa-trash"></i></button>
                <button style="display: none" type="submit" ref="submit_btn"></button>
              </ajax-form>
            </div>

          </ion-card-content>
        </div>
      </div>
      </div>
      <div class="empty-div"></div>
    </master-layout>
    <div v-if="!flag && pageLoaded" class="fix-bottom">
      <div class="d-flex-between">
        <div class="">اقلام: {{ orderItems.length }}</div>
        <div><button class="btn btn-success" @click="flag=true">نمایش فاکتور</button></div>
        <div class="">جمع:
        <Money :number="order_total"></Money>
        </div>
      </div>
    </div>
  </ion-page>
</template>

<script>
import {
  alertController,
  IonCard,
  IonCardContent, IonPage,IonRow,IonCol
} from '@ionic/vue';
import {showSystemNoti} from "@/shared/helper";
import {mapActions} from "vuex";
import AliAjaxSelect from "@/components/aliAjaxSelect";
import AjaxForm from "@/components/AjaxForm";
import Money from "../../components/Money";
import orderItem from "../../components/orderItem";
import Loading from "../../components/Loading";
import {Geolocation} from "@capacitor/core";
import AliSelect from "@/components/aliSelect/index.vue";
import PageLoading from "@/components/PageLoading.vue";
// import NumberInput from "../../components/NumberInput";


export default {
  components: {
    PageLoading,
    Loading,
    AjaxForm,
    AliSelect,
    IonPage,
    IonCardContent, IonCard,orderItem,IonCol,IonRow,
    AliAjaxSelect,Money
  },
  data()
  {
    return {
      location : null,
      pageLoaded : false,
      stock_error : null,
      flag: false,
      showOrderContainer: false,
      customer_id: null,
      customer: null,
      orderItems: [],
      product_id: null,
      order_total: 0,
      order_qty: 0,
      products: [],
      qty_box: 0,
      mission_item_id : null,
      search_product: '',
      brands : [],
      categories : [],
      selectedBrand : null,
      selectedCategory : null,
      showLoading : false,
      oldOrderItem : []
    }
  },
  computed:
  {
    filteredProducts()
    {
      let output = [];
      // if(this.search_product.length)
      // {
      //   for (let i=0; i<this.products.length; i++)
      //   {
      //     if(this.products[i].product_title.toLowerCase().indexOf(this.search_product.toLowerCase())>=0)
      //     {
      //       output.push(this.products[i])
      //     }
      //   }
      //   return output;
      // }
      // else
      //   output = this.products;
      if (this.search_product.length || this.selectedBrand || this.selectedCategory)
      {
        for (let i = 0;i<this.products.length;i++)
        {
          let currentItem = this.products[i];
          if (this.search_product.length)
          {
            if(currentItem.product_title.toLowerCase().indexOf(this.search_product.toLowerCase())===-1)
              continue;
          }
          if (this.selectedBrand)
          {
            if (currentItem.brand_id != this.selectedBrand._id)
              continue;
          }
          if (this.selectedCategory)
          {
            console.log(currentItem.category_id)
            if (currentItem.category_id != this.selectedCategory._id)
              continue;
          }
          output.push(currentItem);

        }
        return output;
      }
      else
        return this.products;
    }
  },
  async mounted()
  {
    await this.init();
  },
  methods: {
    changeBrand(item)
    {
      if (item && item.length)
      {
        this.selectedBrand = item[0];
      }
      else
        this.selectedBrand = null;
    },
    changeCategory(item)
    {
      if (item && item.length)
      {
        this.selectedCategory = item[0];
      }
      else
        this.selectedCategory = null;
    },
    async submitOrder()
    {
      const self = this;
      // if (this.mission_item_id)
      // {
        const s_btn = this.$refs['confirm_submit_btn'];
        const btn_html = s_btn.innerHTML;
        // s_btn.setAttribute('disable','');
        s_btn.innerHTML = 'در حال دریافت موقعیت <i class="far fa-spinner fa-pulse"></i>';
        const options = {
          enableHighAccuracy: true,
        };
        try
        {
          const l = await Geolocation.getCurrentPosition(options);
          if (l)
          {
            this.location = JSON.stringify({lat: l.coords.latitude, lng: l.coords.longitude});
            setTimeout(function (){
              self.$refs['submit_btn'].click();
              s_btn.innerHTML = btn_html;
            },200);
          }
        }
        catch (e)
        {
          s_btn.innerHTML = btn_html;
          return showSystemNoti('danger','برای ثبت باید دسترسی به موقعیت داده شود.');
        }
      // }
      // else
      //   this.$refs['submit_btn'].click();
    },
    async confirmRemoveFactor ()
    {
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'آیا اطمینان دارید!',
            message: 'آیتم های سفارش حذف شود.',
            buttons: [
              {
                text: 'لفو',
                role: 'cancel',
                cssClass: 'danger',
                handler: blah =>
                {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: 'تایید',
                handler: async () =>
                {
                  this.removeFactor();
                },
              },
            ],
          });
      return alert.present();
    },
    setItem(newItem,index)
    {
      this.orderItems[index] = newItem;
      this.calculateOrderItems();
    },
    setOrderItemsQuantity()
    {
      const orderItems = this.orderItems;
      const products = this.products;
      for (let i = 0; i < products.length; i++)
      {
        products[i].selected_qty = 0;
      }
      for (let i = 0; i < orderItems.length; i++)
      {
        const obj = products.find(({_id})=>_id === orderItems[i]._id)
        if (obj.current_unit === 'big')
          obj.selected_qty = Math.ceil(orderItems[i].selected_qty / obj.bigger_unit_quantity);
        else
          obj.selected_qty = orderItems[i].selected_qty;
      }
    },
    async init()
    {
      this.pageLoaded = false;
      this.flag = false;
      this.showOrderContainer = false;
      this.customer_id = null;
      this.customer = null;
      this.orderItems = [];
      this.product_id = null;
      this.order_total = 0;
      this.order_qty = 0;
      this.products = [];
      this.qty_box = 0;
      this.mission_item_id = null;
      this.search_product = '';
      this.oldOrderItem = [];
      const customer_id = this.$route.params.customer_id;
      this.mission_item_id = this.$route.params.mission_item_id;
      this.showLoading = true;
      if (customer_id)
      {
        const check = await this.getCustomer(customer_id);
        if (check.ok)
        {
          const customer = check.customer;
          this.customer_id = customer_id;
          this.customer = customer;
          const result = await this.getCustomerProduct(this.customer._id);
          if (result.ok)
          {
            this.brands = result.brands;
            this.categories = result.categories;
            this.products = result.products;
            for (let i = 0; i < this.products.length; i++)
            {
              this.products[i].total = 0;
              this.products[i].selected_qty = '';
              if (this.products[i].bigger_unit)
                this.products[i].current_unit = 'big';
              else
                this.products[i].current_unit = 'small';
              this.products[i].total = this.products[i].price;
            }
          }
        }
      }
      this.showLoading = false;
      this.pageLoaded = true;
    },
    changeProductItems(){
      const self = this;
      const products = this.products;
      for (let i = 0; i < products.length; i++)
      {
        if (products[i].selected_qty > 0)
        {
          self.addProductOrder(i);
        }
        else
        {
          self.removeItem(i);
        }
      }
      this.setOrderTotal();
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ...mapActions("customer", {
      getCustomer: 'getCustomer'
    }),
    ...mapActions("order", {
      getCustomerProduct: 'getCustomerProduct'
    }),
    ...mapActions('app',{
      getAndSaveOrderCount:"getActiveOrderCount"
    }),
    changeUnit(event, index)
    {
      const val = event.target.value;

      const product = this.filteredProducts[index];
      if (val === 'small')
      {
        // product.price = product.price / product.bigger_unit_quantity;
        product.qty_box = null;
      }
      else
      {
        // product.price = product.price * product.bigger_unit_quantity;
        product.qty_box = Number((product.quantity / product.bigger_unit_quantity).toFixed(2));
        // product.qty_num = product.quantity - product.bigger_unit_quantity;
      }
      this.products[index].total = this.products[index].selected_qty * this.products[index].price;
    },
    setQty(index)
    {
      const selected_qty = this.products[index].selected_qty;
      if (this.products[index].qty_box > 0 && selected_qty > this.products[index].qty_box)
      {
        let text = 'حداکثر&nbsp;' + this.products[index].qty_box + '&nbsp;' + this.products[index].bigger_unit_title;
        text += ' میتوانید اضافه کنید.';
        showSystemNoti('danger', text);
      }
      else if (!this.products[index].qty_box && selected_qty > this.products[index].quantity)
      {
        let text = 'حداکثر&nbsp;' + this.products[index].quantity;
        text += 'عدد میتوانید اضافه کنید.';
        showSystemNoti('danger', text);
      }
      else
        this.products[index].total = selected_qty * this.products[index].price;
    },
    changeCustomer: async function (items)
    {
      let customer = null;
      if (items && items.length)
      {
        customer = items[0];
        this.customer = customer;
        this.showLoading = true;
        const result = await this.getCustomerProduct(this.customer._id);
        if (result.ok)
        {
          this.brands = result.brands;
          this.categories = result.categories;
          this.products = result.products;
          for (let i = 0; i < this.products.length; i++)
          {
            this.products[i].total = this.products[i].price;
            this.products[i].selected_qty = 0;
            if(this.products[i].bigger_unit)
              this.products[i].current_unit = 'big';
            else
              this.products[i].current_unit = 'small';
          }
        }
        else
        {
          this.products = [];
          this.orderItems = [];
        }
      }
      else
      {
        this.customer = null;
        this.products = [];
        this.orderItems = [];
      }
      this.showLoading = false;
    },
    addProductOrder: async function (index)
    {
      const p = JSON.parse(JSON.stringify(this.products[index]));
      if (p.current_unit === 'big')
      {
        p.selected_qty = p.selected_qty * p.bigger_unit_quantity;
      }
      if (this.orderItems.length > 0)
      {
        let index_found = false;
        for (let i = 0; i < this.orderItems.length; i++)
        {
          if (this.orderItems[i]._id === p._id)
          {
            index_found = i;
            break;
          }
        }
        if (index_found !== false)
          this.orderItems[index_found] = p;
        else
          this.orderItems.push(p);
      }
      else
        this.orderItems.push(p);


      this.setOrderTotal();
    },
    removeItem: function (index)
    {
      this.orderItems.splice(index, 1);
      this.setOrderTotal();
    },
    setOrderTotal: function ()
    {
      this.order_total = 0;
      this.order_qty = 0;
      for (let i = 0; i < this.orderItems.length; i++)
      {
        let s_q = parseInt(this.orderItems[i].selected_qty);
        if (isNaN(s_q))
          s_q = 0;
        this.order_total += s_q * this.orderItems[i].price;
        this.order_qty += s_q;
      }
    },
    removeFactor: function ()
    {
      this.orderItems = [];
    },
    decrement: function(index) {
      const currentItem = this.filteredProducts[index];
      if (currentItem.selected_qty === 0)
        return false;
      currentItem.selected_qty = parseInt(currentItem.selected_qty) - 1;
      return false;
    },
    increment: function(index) {

      const currentItem = this.filteredProducts[index];
      if (!currentItem.selected_qty)
        currentItem.selected_qty = 0;
      currentItem.selected_qty = parseInt(currentItem.selected_qty)+1;
      // this.addProductOrder(index)
      return false;
    },
    calculateOrderItems(){
      const orderItems = this.orderItems;
      let stock_error = false;
      for (let i = 0; i < orderItems.length; i++)
      {
        const item = orderItems[i];
        if (item.selected_qty > item.quantity)
          stock_error = true;
        if (item.selected_qty)
          item.total = item.selected_qty * item.price;
        else
          item.total = 0;

      }
      this.stock_error = stock_error;
      this.setOrderTotal();

    },
    submitOrderCallback(data)
    {
      const self = this;
      if (data && data.ok)
      {
        this.init();
        showSystemNoti('success',data.message,function (){
          if (self.mission_item_id)
          {
            self.$router.replace({path : '/mission/customerInfo/'+self.mission_item_id});
          }
        });
        this.getAndSaveOrderCount();
      }
      else
        return showSystemNoti('danger',data.error);
    },
    reRender()
    {
      this.init();
    }
  },
  watch: {
    "$route.path": {
      handler(newUrl,oldUrl)
      {
        if (newUrl.toLowerCase().indexOf('order/add') >= 0 && oldUrl.toLowerCase().indexOf('order/add') < 0)
        {
          this.init();
        }
      },
      deep:true
    },
    products : {
      handler()
      {
        this.changeProductItems();
      },
      deep: true,
    },
    orderItems : {
      handler()
      {
        this.calculateOrderItems();
      },deep : true
    },
    flag : {
      handler(after){
        if (!after)
        {
          this.setOrderItemsQuantity();
        }
      },deep:true
    }
  }
}
</script>

<style scoped>
.plans{
  margin-left: 6px;
  text-shadow: 0px 0px 2px black;
  padding: 0 5px;
  color: white;
  margin-bottom: 5px;
  display: inline-block;
}
.p-1
{
  padding: 5px;
}

.pb-1
{
  padding-bottom: 9px;
}
.end-list-products {
  display: flex;
  justify-content: space-between;
}
.input-quantity {
  width: 50px;
}
.mb-1
{
  margin-bottom: 7px;
}
.d-flex-between{
  display: flex;
  justify-content: space-between;
  align-self: center;
}
.border-bottom
{
  border-bottom: 1px solid silver;
}
.mt-1
{
  margin-top: 7px;
}
.img-div
{
  width: 120px;
  margin: 0 auto;
}
.img-div img
{
  width: 120px;
  height: 120px;
  object-fit: contain;
}
.product-card
{
  text-align: center;
  margin: 10px!important;
}
.product-card ion-card-content
{
  padding: 10px!important;
}

/*input control*/
* {
  box-sizing: border-box;
}

.input-number {
  width: 80px;
  padding: 0 12px;
  vertical-align: top;
  text-align: center;
  outline: none;
  background: transparent;
}

.input-number,
.input-number-decrement,
.input-number-increment {
  border: 1px solid #ccc;
  height: 40px;
  user-select: none;
}

.input-number-decrement,
.input-number-increment {
  display: inline-block;
  width: 30px;
  line-height: 38px;
  background: #f1f1f1;
  color: #444;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
}
.input-number-decrement:active,
.input-number-increment:active {
  background: #ddd;
}

.input-number-decrement {
  border-left: none;
  border-radius: 0 4px 4px 0;
}

.input-number-increment {
  border-right: none;
  border-radius: 4px 0 0 4px;
}
.fix-bottom {
  position: fixed;
  bottom: 53px;
  width: 100%;
  background: #172e79;
  color: white;
  padding: 0 10px;
}
.d-flex-between > div
{
  align-self: center;
}
.empty-div
{
  width: 100%;
  height: 35px;
}
.table
{
  text-align: center;
}
.div-danger
{
  background: #fff3cd;
  border: 1px solid #ffecb5;
  color: #664d03;
}
body{
  margin: 0;
  padding: 0;
  background: #262626;
}

.pulse{
  border-radius: 50%;
  /*width: 20px;*/
  /*height: 20px;*/
  color: red;
  text-align: center;
  animation: animate-pulse 3s linear infinite;
  font-size: 11px!important;
}
.search-input
{
  border-radius: 0!important;
}

@keyframes animate-pulse{
  0%{
    box-shadow: 0 0 0 0 rgba(255,109,74,0.7),  0 0 0 0 rgba(255,109,74,0.7);
  }
  40%{
    box-shadow: 0 0 0 25px rgba(255,109,74,0.0),  0 0 0 0 rgba(255,109,74,0.7);
  }
  80%{
    box-shadow: 0 0 0 25px rgba(255,109,74,0.0),  0 0 0 15px rgba(255,109,74,0);
  }
  100%{
    box-shadow: 0 0 0 0 rgba(255,109,74,0.0),  0 0 0 15px rgba(255,109,74,0);
  }

}
.form-check-inline
{
  display: inline-block;
  margin-left: 15px;
}
.d-block
{
  display: block;
}

</style>